<template>
  <div id="user-info-page-container" class="user-info-page" v-if="!isLoading">
   <c-banner-user-info />
    <c-sub-section-info />
    <c-rules-section-info />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import cBannerUserInfo from '../../components/user-info/UserInfoBanner.vue'
import cSubSectionInfo from '../../components/user-info/UserInfoSubSection.vue'
import cRulesSectionInfo from '../../components/user-info/RulesContent.vue'

export default {
  name: 'User-info',
  components: {
    cBannerUserInfo,
    cSubSectionInfo,
    cRulesSectionInfo
  },
  mounted () {
    const hasVisitedBefore = localStorage.getItem('hasVisitedBefore')

    if (!hasVisitedBefore) {
      this.actionPreloader(true)

      localStorage.setItem('hasVisitedBefore', 'true')

      setTimeout(() => {
        this.actionPreloader(false)
      }, 2000)
    }
  },
  computed: {
    ...mapState({
      isLoading: state => state.preloader.isLoading
    })
  },
  methods: {
    ...mapActions(['actionPreloader'])
  }
}
</script>
<style lang="scss" scoped>
  #user-info-page-container{
    padding-top: 96px;
  }
</style>
